import { PriceType, ProductType } from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';
export function toProductValue(product, value) {
    return {
        productId: product.id,
        price: value,
        quantity: 1
    };
}
export function toPriceNumber(value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const parsed = Number(String(value).replace(/,/g, '.'));
    return Number.isNaN(parsed) ? undefined : parsed;
}
export function aDynamicPricePayment(id = generateUUID(), min = 1, max) {
    return {
        id,
        priceType: PriceType.DYNAMIC_PRICE,
        productType: ProductType.DIGITAL,
        quantityLimit: {
            minimum: 1,
            maximum: 1
        },
        dynamicPriceOptions: {
            minPrice: String(min),
            maxPrice: max ? String(max) : undefined
        }
    };
}

//# sourceMappingURL=payment-input-field-utils.js.map